<div class="container-fluid">
  <h4>{{'Spreadsheets.header' | translate}}</h4>
  <div class="row">
    <div class="col-6">
      <h5>{{'Spreadsheets.lblMarketRates' | translate}}</h5>
      @if (spreadsheets.marketRates !== null) {
        <div class="mt-3 ml-3">
          @for (marketRate of spreadsheets.marketRates; track marketRate) {
            <div>
              <h6>{{marketRate.marketName}}</h6>
              @if (marketRate.availableSpreadsheets !== null) {
                <ul>
                  @for (spreadsheet of marketRate.availableSpreadsheets; track spreadsheet) {
                    <li style="list-style-type: none; color: blue;" class="clickable" (click)="OnClickSpreadsheet(spreadsheet)">
                      <i style="font-size: 1em;" class="fa fa-file-excel-o clickable text-success" aria-hidden="true"></i> &nbsp;<u>{{spreadsheet.id}}</u>
                    </li>
                  }
                </ul>
              }
              @if (marketRate.availableSpreadsheets === null) {
                <ul>
                  <li style="list-style-type: none;">
                    <i style="font-size: 1em;" class="fa fa-file-excel-o clickable text-success" aria-hidden="true"></i>&nbsp;{{'Spreadsheets.lblNoRatesSpreadsheets' | translate}}
                  </li>
                </ul>
              }
            </div>
          }
        </div>
      }
      @if (spreadsheets.marketRates === null && isLoading === false) {
        <div>
          {{'Spreadsheets.lblNoMarketRates' | translate}}
        </div>
      }
      @if (spreadsheets.marketRates === null && isLoading === true) {
        <div>
          <i>{{'tblLoading' | translate}}...</i>
        </div>
      }
    </div>
    <div class="col-6">
      <h5>{{'Spreadsheets.lblMarketContributions' | translate}}</h5>
      @if (spreadsheets.marketContributions !== null) {
        <div class="mt-3 ml-3">
          @for (marketContribution of spreadsheets.marketContributions; track marketContribution) {
            <div>
              <h6>{{marketContribution.marketName}}</h6>
              @if (marketContribution.availableSpreadsheets !== null) {
                <ul>
                  @for (spreadsheet of marketContribution.availableSpreadsheets; track spreadsheet) {
                    <li style="list-style-type: none; color: blue;" class="clickable" (click)="OnClickSpreadsheet(spreadsheet)">
                      <i style="font-size: 1em;" class="fa fa-file-excel-o clickable text-success" aria-hidden="true"></i>&nbsp; <u>{{spreadsheet.id}}</u>
                    </li>
                  }
                </ul>
              }
              @if (marketContribution.availableSpreadsheets === null) {
                <ul>
                  <li style="list-style-type: none;">
                    <i style="font-size: 1em;" class="fa fa-file-excel-o clickable text-success" aria-hidden="true"></i>&nbsp; {{'Spreadsheets.lblNoContributionsSpreadsheets' | translate}}
                  </li>
                </ul>
              }
            </div>
          }
        </div>
      }
      @if (spreadsheets.marketContributions === null && isLoading === false;) {
        <div>
          {{'Spreadsheets.lblNoMarketContributions' | translate}}
        </div>
      }
      @if (spreadsheets.marketContributions === null && isLoading === true;) {
        <div>
          <i>{{'tblLoading' | translate}}...</i>
        </div>
      }
    </div>
  </div>
</div>